export enum EndpointsEnum {
  ARTICLES = 'articles',
  ARTICLE_TYPES = 'article-types',
  CALC = 'calc',
  DISTRICTS = 'districts',
  DOCUMENTS = 'documents',
  DOCUMENT_TYPE = 'document-type',
  DOWNLOAD = 'download',
  FACILITIES = 'facilities',
  FILE = 'file',
  LOGIN = 'auth/login',
  AUTH_REFRESH = 'auth/refresh',
  AUTH_LOGOUT = 'auth/logout',
  CONNECTIONS = 'connections',
  EVENTS_MY = 'events/my',
  PARTNERS = 'partners',
  PAGES = 'pages',
  RECORDS = 'records',
  SHUTDOWNS = 'shutdowns',
  UPLOAD = 'upload',
  USERS = 'users',
}